import basement from "../static/images/art/basement.webp";
import muralBasement from "../static/images/art/mural-basement.webp";
import muralSpecs from "../static/images/art/mural-specs.webp";
import previous_intro from "../static/images/art/previous_intro.webp";
import previous_1 from "../static/images/art/previous_1.webp";
import previous_2 from "../static/images/art/previous_2.webp";
import previous_3 from "../static/images/art/previous_3.webp";
import previous_4 from "../static/images/art/previous_4.webp";
import previous_5 from "../static/images/art/previous_5.webp";
import previous_6 from "../static/images/art/previous_6.webp";
import previous_7 from "../static/images/art/previous_7.webp";
import current_intro from "../static/images/art/current_intro.webp";
import current_1 from "../static/images/art/current_1.webp";
import current_2 from "../static/images/art/current_2.webp";
import current_3 from "../static/images/art/current_3.webp";
import coming_intro from "../static/images/art/coming_intro.webp";
import coming_1 from "../static/images/art/coming_1.webp";
import coming_2 from "../static/images/art/coming_2.webp";
import coming_3 from "../static/images/art/coming_3.webp";
import dsLogo from "../static/dots_pattern.png";
import kumar_intro from "../static/images/art/kumar_intro.webp";

const blogData = [
  {
    id: 0,
    title: "OPEN CALL",
    intro:
      "We're welcoming submissions for a new mural art piece for our club basement.",
    introImage: basement,
    mainImage: [basement, muralBasement, muralSpecs],
  },
  {
    id: 1,
    title: "‘A Song For the Room’ by Abhay Kumar",
    intro: "Chalice Cox-Hynd",
    introImage: kumar_intro,
    mainImage: [kumar_intro],
  },
  {
    id: 2,
    title: "CURRENT",
    intro: "March '23",
    introImage: current_intro,
    mainImage: [current_1, current_2, current_3],
  },
  {
    id: 3,
    title: "COMING",
    intro: "April '23",
    introImage: coming_intro,
    mainImage: [coming_1, coming_2, coming_3],
  },
  {
    id: 4,
    title: "PREVIOUS",
    intro: "September '22 - February '23",
    introImage: previous_intro,
    mainImage: [
      previous_1,
      previous_2,
      previous_3,
      previous_4,
      previous_5,
      previous_6,
      previous_7,
    ],
  },
];

export default blogData;
